import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useEffect, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInputField, Hint } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import { useLinkContext } from '../../../contexts/internal/LinkContext.js';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import '../../../components/Canvas/Canvas.style.js';
import '../../../components/Canvas/PreviewModeContainer.js';
import '../../../components/Duration/DurationInput.js';
import '../../../components/FieldItem.js';
import '../../../components/FormGroup/FormGroup.js';
import { LogDataFormGroup } from '../../../components/FormGroup/LogDataFormGroup.js';
import '../../../components/Header/index.js';
import '../../../components/Input/ColorPickerField/index.js';
import '../../../components/Input/URLInput.js';
import '../../../components/Inspector/Inspector.js';
import '../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../components/Tooltip/Tooltip.js';
import '../../../components/Toolbar/Toolbar.style.js';
import '../../../components/TreeList/Draggable.js';
import '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../../components/FormContent.js';
import { InspectorFormProvider } from '../../../components/InspectorFormProvider.js';

var _excluded = ["children"];
function ImageMapBrazeInspector(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return jsx(InspectorFormProvider, {
    value: value,
    onChange: onChange
  }, jsx(ImageMapBrazeForm, {
    value: value
  }), jsx(LogDataInput, {
    value: value
  }));
}
function ImageMapBrazeForm(_ref2) {
  var _value$props;
  var value = _ref2.value;
  var _useFormContext = useFormContext(),
    setValue = _useFormContext.setValue;
  var _ref3 = (_value$props = value === null || value === void 0 ? void 0 : value.props) !== null && _value$props !== void 0 ? _value$props : {},
    style = _ref3.style;
  useEffect(function () {
    setValue('style', style);
  }, [style, setValue]);
  return jsx(React__default.Fragment, null, jsx(FormContent, {
    header: "Braze \uCEE4\uC2A4\uD140 \uC774\uBCA4\uD2B8 \uC774\uB984",
    required: true
  }, jsx(TextInputField, {
    name: "customEventName",
    width: "100%"
  }), jsx(Hint, {
    error: true
  }, "Braze\uB85C \uC801\uC7AC\uD560 \uC774\uBCA4\uD2B8\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694. \uBE48 \uCE78\uC77C\uACBD\uC6B0 \uC774\uBCA4\uD2B8\uAC00 \uC801\uC7AC\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.")), jsx(FormContent, {
    header: "URL"
  }, jsx(TextInputField, {
    name: "url",
    width: "100%"
  })), jsx(FormContent, {
    header: "URL \uBBF8\uC785\uB825 \uC2DC \uB098\uC624\uB294 \uD1A0\uC2A4\uD2B8 \uBA54\uC138\uC9C0"
  }, jsx(TextInputField, {
    name: "message",
    width: "100%"
  })));
}
var LogDataInput = /*#__PURE__*/memo(function (_ref4) {
  var _value$props2;
  var value = _ref4.value;
  var _useLinkContext = useLinkContext(),
    setLogData = _useLinkContext.setLogData;
  var _ref5 = value !== null && value !== void 0 ? value : {};
    _ref5.children;
    var others = _objectWithoutProperties(_ref5, _excluded);
  return jsx(LogDataFormGroup, _extends({
    nodeKey: value === null || value === void 0 ? void 0 : value.key
  }, setLogData === null || setLogData === void 0 ? void 0 : setLogData(_objectSpread2(_objectSpread2({}, others), {}, {
    props: {
      logData: value === null || value === void 0 || (_value$props2 = value.props) === null || _value$props2 === void 0 ? void 0 : _value$props2.logData
    }
  }))));
});

export { ImageMapBrazeInspector };
//# sourceMappingURL=ImageMapBraze.Inspector.js.map
